import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  IWordPluginAccessConfig,
  IWordPluginAccessStatus,
} from '../../Interfaces/IWordPluginAccess';
import { customFetcher } from '../useFetch';

const CONFIG_KEY = ['word-plugin', 'config'];
const STATUS_KEY = ['word-plugin', 'status'];

/**
 * Ist das Word-Plugin für den angemeldeten Benutzer freigeschaltet (#1245)?
 * Urkundenerstellung im Vorgang und „Dokumentvorlagen" blenden sich danach aus.
 * Solange die Antwort fehlt, gilt: aus.
 */
export const useGetWordPluginStatus = () => {
  const { data, isLoading: isLoadingWordPluginStatus } =
    useQuery<IWordPluginAccessStatus>({
      queryKey: STATUS_KEY,
      queryFn: () => customFetcher({ endpoint: '/word-plugin/status' }),
      refetchOnWindowFocus: false,
    });

  return {
    isWordPluginEnabled: data?.Enabled === true,
    isLoadingWordPluginStatus,
  };
};

/** Hauptschalter und freigeschaltete Benutzer — nur mit Entwickler-Zugang (`dev`). */
export const useGetWordPluginConfig = () => {
  const { data: wordPluginConfig, isLoading: isLoadingWordPluginConfig } =
    useQuery<IWordPluginAccessConfig>({
      queryKey: CONFIG_KEY,
      queryFn: () => customFetcher({ endpoint: '/word-plugin/config' }),
    });

  return { wordPluginConfig, isLoadingWordPluginConfig };
};

export const useSaveWordPluginConfig = () => {
  const queryClient = useQueryClient();
  const {
    mutateAsync: saveWordPluginConfig,
    isPending: isPendingSaveWordPluginConfig,
  } = useMutation({
    mutationFn: (uploadObject: Partial<IWordPluginAccessConfig>) =>
      customFetcher({
        endpoint: '/word-plugin/config',
        body: uploadObject,
        method: 'PUT',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CONFIG_KEY });
      // Wer sich selbst freischaltet, sieht die Einstiege sofort.
      queryClient.invalidateQueries({ queryKey: STATUS_KEY });
    },
  });

  return { saveWordPluginConfig, isPendingSaveWordPluginConfig };
};
